import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=3bc0bd48"
import script from "./ApprovalView.ts?vue&type=script&lang=ts&external"
export * from "./ApprovalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports